<script setup lang="ts">
import { useCostStore } from '@/stores/cost'
import { storeToRefs } from 'pinia'
import CostUnitRates from '@/components/cost-co2/CostUnitRates.vue'

const costStore = useCostStore()

const { currentItem: currentCostItem } = storeToRefs(costStore)
</script>

<template>
  <template v-if="!currentCostItem">
    <div class="d-flex justify-center align-center fill-height">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </div>
  </template>
  <template v-else>
    <div class="px-8 py-6">
      <CostUnitRates v-if="costStore.currentItem" />
    </div>
  </template>
</template>

<style scoped></style>
